import { render, staticRenderFns } from "./Anonymisieren.vue?vue&type=template&id=1fa13b00&scoped=true"
import script from "./Anonymisieren.vue?vue&type=script&lang=js"
export * from "./Anonymisieren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa13b00",
  null
  
)

export default component.exports